import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  Pagination,
} from "@windmill/react-ui";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { GetCtiLog } from "../../api/Actions/ServiceCTI";
import moment from "moment/moment";
import toast, { Toaster } from "react-hot-toast";
import Datepicker from "react-tailwindcss-datepicker";

export default function History() {
  const dispatch = useDispatch();
  const endTime = moment().format("YYYY-MM-DD");
  const startDate = moment(endTime).add(-30, "days").format("YYYY-MM-DD");
  // date range picker
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });

  // cti log filter
  const [Filter, setFilter] = useState({
    type: "incoming",
    status: "answered",
    // startTime: "",
    // endTime: "",
    page: 1,
    total_page: 1,
    search: "",
  });

  // search bar
  const [Search, setSearch] = useState("");

  const CtiLog = useSelector((state) => state.CtiCredential.GetCtiLog);
  const CtiLogError = useSelector(
    (state) => state.CtiCredential.errorGetCtiLog
  );

  // handle changed value datepicker
  const handleValueChange = (newValue) => {
    // console.log("newValue:", newValue, newValue.startDate);
    setValue(newValue);
    setFilter((prevState) => ({
      ...prevState,
      page: 1,
      startTime: newValue.startDate,
      endTime: newValue.endDate,
    }));
  };

  const CopyUrl = (data) => {
    navigator.clipboard.writeText(data);
    toast("Copied");
  };

  const HandleFilter = (type, data) => {
    // handling cti log filter
    switch (type) {
      case "DateRange":
        const startDate = moment(endTime)
          .add(-Number(data), "days")
          .format("YYYY-MM-DD");
        setFilter((prevState) => ({
          ...prevState,
          page: 1,
          startTime: startDate,
        }));
        break;
      case "CallStatus":
        setFilter((prevState) => ({
          ...prevState,
          page: 1,
          status: data,
        }));
        break;
      case "CallType":
        setFilter((prevState) => ({
          ...prevState,
          page: 1,
          type: data,
        }));
        break;
      case "Search":
        setFilter((prevState) => ({
          ...prevState,
          page: 1,
          search: data,
        }));
        break;
      case "Pagination":
        if (Number(data) !== Filter.page) {
          setFilter((prevState) => ({
            ...prevState,
            page: Number(data),
          }));
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    // get cti log
    const params = {
      page: Filter.page,
      limit: 10,
      // startTime: Filter.startTime,
      // endTime: Filter.endTime,
      query: `orgUuid:${localStorage.getItem("orgUuid")}`,
    };
    dispatch(GetCtiLog(params));
  }, []);

  useEffect(() => {
    const params = {
      page: Filter.search !== "" ? 1 : Filter.page,
      limit: 10,
      startTime: Filter.startTime,
      endTime: Filter.endTime,
      query:
        (Filter.type !== "" ? `dataReq->>type:${Filter.type} AND ` : "") +
        (Filter.status !== "" ? `dataReq->>status:${Filter.status} AND ` : "") +
        `orgUuid:${localStorage.getItem("orgUuid")}` +
        (Filter.search !== "" ? ` AND txnUuid:${Filter.search.trim()}` : ""),

      // `dataReq->>type:${Filter.type} AND dataReq->>status:${
      //     Filter.status
      //   } AND orgUuid:${localStorage.getItem("orgUuid")}` +
      //   (Filter.search !== "" ? ` AND txnUuid:${Filter.search.trim()}` : ""),
    };
    dispatch(GetCtiLog(params));
  }, [Filter]);

  useEffect(() => {
    // testing condition
    if (CtiLog && CtiLog.data) {
      CtiLog.data.rows.map((element, id) => {
        if (typeof element.dataRes === "string") {
          console.log(typeof element.dataRes, "INI ELEMENTNYA");
        } else {
          if (!element.dataRes[0] || !element.dataRes[0].rows.ticket) {
            // console.log(element.dataRes[0], "INI TIDAK ADA TICKETNYA");
          } else {
            // console.log(element.dataRes, "ADA TICKETNYA");
          }
        }
      });
    }
  }, [CtiLog]);

  // console.log(CtiLog, "DATA TICKETNYA GAN");
  return (
    <div className="flex flex-col mt-4 shadow-inner bg-slate-100 rounded-xl h-full w-full overflow-y-auto">
      <div className="flex flex-col sm:flex-row w-full sm:p-6 justify-between">
        <div className="flex flex-col sm:flex-row text-xs w-3/4">
          <div className="flex flex-col sm:flex-row text-sm w-full mt-4 mb-2">
            <div className="flex my-auto border drop-shadow-md rounded-md mx-6 h-8 sm:w-full">
              <i className="fa-solid fa-magnifying-glass my-auto ml-2" />
              <input
                onChange={(e) => HandleFilter("Search", e.target.value)}
                className="bg-transparent pl-2 ring-0 outline-none w-full"
                type="text"
                placeholder="Search"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row text-xs w-full">
          <div className="flex flex-col mx-4">
            <label className="poppins-500 mb-2">Call Type</label>
            <select
              onChange={(e) => HandleFilter("CallType", e.target.value)}
              className="bg-transparent border-b border-black"
            >
              <option value="">All</option>
              <option value="incoming">Incoming</option>
              <option value="outgoing">Outgoing</option>
            </select>
          </div>
          <div className="flex flex-col mx-4">
            <label className="poppins-500 mb-2">Call Status</label>
            <select
              onChange={(e) => HandleFilter("CallStatus", e.target.value)}
              className="bg-transparent border-b border-black"
            >
              <option value="">All</option>
              <option value="answered">Answered</option>
              <option value="unanswered">Unanswered</option>
            </select>
          </div>
          <div className="flex flex-col mx-4 w-full">
            <label className="poppins-500">Data Range</label>
            <Datepicker
              value={value}
              onChange={handleValueChange}
              showShortcuts={true}
            />
          </div>
        </div>
      </div>
      <div>
        <div className="flex flex-col w-full h-full">
          <TableContainer className="w-auto">
            <Table>
              <TableHeader>
                <TableRow className="col">
                  <TableCell className="content-center poppins-800">
                    TXN UUID
                  </TableCell>
                  <TableCell className="content-center poppins-800">
                    Ticket No
                  </TableCell>
                  <TableCell className="content-center poppins-800">
                    Connector
                  </TableCell>
                  <TableCell className="content-center poppins-800">
                    Call Type
                  </TableCell>
                  <TableCell className="content-center poppins-800">
                    Ticket Link
                  </TableCell>
                  <TableCell className="text-center content-center poppins-800">
                    Status
                  </TableCell>
                </TableRow>
              </TableHeader>
              {CtiLog.data && CtiLog.data.count > 0 ? (
                <TableBody>
                  {CtiLog.data.rows.map((element, id) => {
                    return (
                      <TableRow key={id} className="text-xs sm:text-base">
                        <TableCell>
                          <p
                            onClick={() => CopyUrl(element.txnUuid)}
                            className="cursor-pointer has-tooltip hover:text-blue-500"
                          >
                            {element.txnUuid
                              ? element.txnUuid.slice(0, 15) + "..."
                              : ""}
                          </p>
                        </TableCell>
                        <TableCell>
                          {element.metadata ? element.metadata.ticket_id : "--"}
                        </TableCell>
                        <TableCell>{element.type.name}</TableCell>
                        <TableCell>{element.dataReq.type}</TableCell>
                        <TableCell>
                          <p
                            onClick={() => CopyUrl(element.metadata.ticket_url)}
                            className="cursor-pointer tooltip hover:text-blue-500"
                          >
                            {!element.metadata ? "" : "Copy Url"}
                          </p>
                        </TableCell>
                        <TableCell className="text-center">
                          <p
                            className={
                              (element.status.name === "failed"
                                ? "bg-red-500"
                                : element.status.name === "success"
                                ? "bg-green-500"
                                : "") +
                              " text-white rounded-md text-center py-1 mx-auto lg:w-3/4 font-semibold text-xs capitalize"
                            }
                          >
                            {element.status.name}
                          </p>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              ) : !CtiLog ? (
                <TableBody>
                  <TableRow className="bg-white dark:bg-cool-gray-800 text-center">
                    <TableCell colSpan={6}>
                      {CtiLogError ? (
                        <h1 className="mx-auto">Data Not Found</h1>
                      ) : (
                        <h1 className="mx-auto">Loading Data</h1>
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow className="bg-white dark:bg-cool-gray-800 text-center">
                    <TableCell colSpan={6}>
                      <h1 className="mx-auto">Data Not Found</h1>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
            <TableFooter>
              {CtiLog.data && CtiLog.data.count > 0 ? (
                <Pagination
                  totalResults={CtiLog.data.count}
                  resultsPerPage={10}
                  onChange={(e) => HandleFilter("Pagination", e)}
                  label="Page navigation"
                  activePage={1}
                />
              ) : (
                ""
              )}
            </TableFooter>
          </TableContainer>
          <Toaster
            position="center"
            reverseOrder={false}
            gutter={8}
            containerClassName=""
            containerStyle={{}}
            toastOptions={{
              // Define default options
              className: "",
              duration: 5000,
              style: {
                background: "#363636",
                color: "#fff",
              },

              // Default options for specific types
              success: {
                duration: 3000,
                theme: {
                  primary: "green",
                  secondary: "black",
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}
